import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiClient } from './api.clients.generated';

export interface IcareDocumentTypeOption {
  value: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class IcareService {
  constructor(
    private readonly api: ApiClient,
    private readonly translate: TranslateService
  ) {}

  getPersons(query: string) {
    return this.api.getPersons(query, 0, 10, []);
  }

  getBuildings(personId: string) {
    return this.api.getBuildings(Number(personId), 'en', 0, 10, []);
  }

  getCases(personId: string, buildingId: string) {
    return this.api.getIncidents(Number(personId), Number(buildingId), true, 'en', 0, 10, []);
  }

  getDocumentTypes(): Observable<IcareDocumentTypeOption[]> {
    return this.api.getDocumentTypes().pipe(
      map(options => options.map(option => ({
        value: option.value,
        label: this.translate.instant(`message.attachments.icare.documentTypes.${option.value}`, { defaultValue: option.value })
      })))
    );
  }

}

